import { Modal } from "react-bootstrap";
import { useState, useEffect } from "react";
import { Input, TextArea, InputImage, Select } from "../../../Layout/Forms/Form";
import EventFormRequest from "./EventFormRequest";
import { useNavigate } from "react-router-dom";
import { Puff } from "react-loading-icons";
import Location from "../../Nightspots/Form/Location/Location";
import "../../Campaigns/Campaigns.css";

function EventFormModal({ show, id, handleModalhide, venue_type }) {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const [state, setState] = useState({
    form: {
      id: 0,
      name: "",
      id_venues: id,
      description: "",
      hour_start: "22:30",
      hour_end: "06:00",
      date: "",
      date_end: "",
      timezone: "",
      music_genre: [],
      event_image: "",
      event_image_url: "",
      status: "",
      visibility: "PUBLIC",
      location: {
        address_components: [],
        formatted_address: "",
        geometry: {
          lng: "",
          lat: "",
        },
        place_id: "",
      },
      guestlist: {
        enable: false,
        capacity: "",
        visibility: "PUBLIC",
        blockRegistry: 0,
        promotersList: null,
        allowAppGuestList: true,
      },
      tables: {
        enable: false,
        list: [],
        haveAccess: false,
      },
      tickets: {
        enable: false,
        list: [],
        haveAccess: true,
      },
    },
    errors: {},
  });

  const handleSubmitForm = async () => {
    setIsLoading(true);
    let params = state.form;
    let info = await EventFormRequest.saveEvent(params);

    if (info && info.status) {
      setIsLoading(false);
      handleModalhide();
      navigate("/my/events/update/" + info.data.id);
    } else {
      setState((prevState) => ({
        ...prevState,
        errors: info.errors || {},
      }));
    }
    setIsLoading(false);
  };

  useEffect(() => {
    const { date, date_end } = state.form;
    if (date && (!date_end || date_end.length === 0 || new Date(date_end) < new Date(date))) {
      setState((prevState) => ({
        ...prevState,
        form: {
          ...prevState.form,
          date_end: date,
        },
      }));
    }
  }, [state.form.date]);

  const InsideLoading = () => (
    <div className="d-flex flex-column align-items-center justify-content-center py-5">
      <Puff stroke="#6366f1" height="4em" width="4em" />
      <div className="text-muted mt-3 fw-bold">A preparar evento...</div>
    </div>
  );

  const handleChangeInputs = (e) => {
    if (!isLoading) {
      setState((prevState) => ({
        ...prevState,
        form: {
          ...prevState.form,
          [e.target.name]: e.target.value,
        },
      }));
    }
  };

  const handleChangeInputsLocation = (e) => {
    if (!isLoading) {
      setState((prevState) => ({
        ...prevState,
        form: {
          ...prevState.form,
          location: { ...e },
        },
      }));
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleModalhide}
      centered
      size="lg"
      contentClassName="campaign-card border-0 p-0 overflow-hidden"
    >
      <div className="modal-header border-0 p-4 pb-0 d-flex justify-content-between align-items-center">
        <div>
          <h2 className="campaigns-section-title fs-3 mb-1">Adicionar Evento</h2>
          <p className="campaigns-section-subtitle mb-0 small text-muted">Preenche os detalhes básicos para criar o teu novo evento.</p>
        </div>
        <button
          type="button"
          className="btn btn-sm rounded-circle d-flex align-items-center justify-content-center border-0 bg-white bg-opacity-10 hover-scale"
          onClick={handleModalhide}
          aria-label="Close"
          style={{
            width: '36px',
            height: '36px',
            transition: 'all 0.2s ease'
          }}
        >
          <i className="fa-solid fa-xmark text-white fs-5"></i>
        </button>
      </div>

      {isLoading ? (
        <InsideLoading />
      ) : (
        <>
          <Modal.Body className="p-4 pt-4">
            <div className="row g-4">
              <div className="col-12 col-md-12">
                <Input
                  label="Nome do evento"
                  name="name"
                  placeholder="Ex: Grande Noite de Verão"
                  value={state.form.name}
                  onChange={handleChangeInputs}
                  onPaste={(e) => { e.preventDefault(); handleChangeInputs({ target: { name: e.target.name, value: e.clipboardData.getData('Text') } }) }}
                  className="form-control glass-input"
                  errors={state.errors}
                />
              </div>

              <div className="col-12 col-md-6">
                <Input
                  label="Data de Início"
                  name="date"
                  value={state.form.date}
                  onChange={handleChangeInputs}
                  onPaste={(e) => { e.preventDefault(); handleChangeInputs({ target: { name: e.target.name, value: e.clipboardData.getData('Text') } }) }}
                  type="date"
                  className="form-control glass-input"
                  errors={state.errors}
                />
              </div>

              <div className="col-12 col-md-6">
                <Input
                  label="Data de Fim"
                  name="date_end"
                  value={state.form.date_end}
                  onChange={handleChangeInputs}
                  onPaste={(e) => { e.preventDefault(); handleChangeInputs({ target: { name: e.target.name, value: e.clipboardData.getData('Text') } }) }}
                  type="date"
                  className="form-control glass-input"
                  errors={state.errors}
                />
              </div>
              <div className="col-12 col-md-6">
                <Select
                  label="Visibilidade"
                  name="visibility"
                  value={state.form.visibility}
                  onChange={handleChangeInputs}
                  options={[
                    { value: "PUBLIC", label: "Pública" },
                    { value: "PRIVATE", label: "Privada" },
                  ]}
                  className="form-control glass-input"
                  errors={state.errors}
                />
              </div>

              <div className="col-12">
                <InputImage
                  label="Imagem de Capa (Recomendado 1080x1080)"
                  name="event_image"
                  value={state.form.event_image_url}
                  onChange={(e) =>
                    handleChangeInputs({
                      target: { name: "event_image", value: e },
                    })
                  }
                  errors={state.errors}
                />
              </div>

              <div className="col-12">
                <TextArea
                  label="Descrição do Evento"
                  name="description"
                  placeholder="Descreve o evento..."
                  value={state.form.description}
                  onChange={handleChangeInputs}
                  onPaste={(e) => { e.preventDefault(); handleChangeInputs({ target: { name: e.target.name, value: e.clipboardData.getData('Text') } }) }}
                  className="form-control glass-input"
                  errors={state.errors}
                  rows={4}
                />
              </div>

              {venue_type !== 'venue' && (
                <div className="col-12">
                  <div className="instruction-box p-3 rounded-4 border border-white border-opacity-10">
                    <Location
                      visible
                      handleChangeForm={handleChangeInputsLocation}
                      form={state.form.location}
                    />
                  </div>
                </div>
              )}
            </div>
          </Modal.Body>

          <Modal.Footer className="border-0 p-4 pt-0 mt-2">
            <button
              className="btn-action btn-campaign-secondary px-4 py-2 rounded-pill w-auto me-2"
              onClick={handleModalhide}
            >
              Fechar
            </button>
            <button
              className="btn-action glass-glow btn-campaign-primary px-5 py-2 rounded-pill w-auto"
              onClick={handleSubmitForm}
            >
              <i className="fa-solid fa-floppy-disk me-2"></i>Guardar e Continuar
            </button>
          </Modal.Footer>
        </>
      )}
    </Modal>
  );
}

export default EventFormModal;
